import React from "react";
import { MentionableUserFragment } from "__generated__/graphql";
import { getEmployeeDisplayName } from "employee/helpers/getEmployeeDisplayName";
import { useTranslation } from "react-i18next";

interface IDisplayTemplateProps {
  data: MentionableUserFragment;
}
export const DisplayTemplate: React.FC<IDisplayTemplateProps> = ({ data }) => {
  const { t: translate } = useTranslation("common");
  return (
    <span style={{ color: "blue" }} data-mention-email={data.employee?.email}>
      @
      {data.employee
        ? getEmployeeDisplayName(data.employee)
        : translate("rich_text_editor.unknown_employee")}
    </span>
  );
};
